import { uniq } from 'lodash';
import {
  ADD_NOTIFICATION,
  CLOSE_NOTIFICATION,
  CLOSE_UI_MODAL,
  END_REQUEST_LOADING,
  OPEN_UI_MODAL,
  RESET_FORM_VALUES,
  START_REQUEST_LOADING,
  UIReducerProps,
  UPDATE_FORM_VALUE,
  UPDATE_TAB_VALUE,
} from '../../actions/ui/types';
import { FieldType } from '@amzn/coral_com-amazon-transreportscenterservice';

export const initialState = {
  loading: false,
  pendingRequests: [],
  notifications: [],
  form: {},
  currentSelectedTab: ''
};

export default function ui(state: UIReducerProps = initialState, action: any) {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      };
    case CLOSE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          ({ id }: any) => id !== action.payload
        ),
      };

    case START_REQUEST_LOADING: {
      return {
        ...state,
        pendingRequests: uniq([...state.pendingRequests, action.payload]),
      };
    }

    case END_REQUEST_LOADING: {
      return {
        ...state,
        pendingRequests: state.pendingRequests.filter(
          (call) => call !== action.payload
        ),
      };
    }

    case OPEN_UI_MODAL: {
      return {
        ...state,
        openedModal: action.payload,
      };
    }
    case CLOSE_UI_MODAL: {
      return {
        ...state,
        openedModal: {},
      };
    }
    case UPDATE_FORM_VALUE: {
      if (action.payload.queryDynamicParameterName.toLowerCase().includes('start')) {
        return {
          ...state,
          form: {
            ...state.form,
            [action.payload.queryDynamicParameterName]: {
              value: action.payload.value,
              fieldType: action.payload.fieldType,
            },
            [action.payload.queryDynamicParameterName.replace('START','END')]: {
              value: [],
              fieldType: action.payload.fieldType,
            },
          },
        };
      }
      return {
        ...state,
        form: {
          ...state.form,
          [action.payload.queryDynamicParameterName]: {
            value: action.payload.value,
            fieldType: action.payload.fieldType,
          },
        },
      };
    }
    case RESET_FORM_VALUES: {
      return {
        ...state,
        form:{},
      };
    }
    case UPDATE_TAB_VALUE: {
      return {
        ...state,
        currentSelectedTab: action.payload,
      };
    }
    default:
      return state;
  }
}
